import { ApiClients } from '@roolz/api/clients'
import { ResetPasswordByTokenRequest, VerifyEmailRequest } from '@roolz/types/api/auth'
import {
  AuthResponse,
  checkTokenExpiration,
  getMagicLink,
  getResetPasswordLink,
  LoginByEmailRequest,
  loginByMagicLink,
  loginByMagicLinkToken,
  LoginBySmsRequest,
  loginBySocialNetwork,
  RefreshTokenRequest,
  RefreshTokenResponse
} from '@roolz/types/api/profiles'
import { AxiosInstance } from 'axios'

export class AuthApi {
  identity: AxiosInstance
  identity2: AxiosInstance

  constructor(clients: ApiClients) {
    this.identity = clients.identity
    this.identity2 = clients.identity2
  }
  refreshToken(body: RefreshTokenRequest) {
    return this.identity2.post<RefreshTokenResponse>('/v1/public/auth/token/refresh', body)
  }

  checkTokenExpiration(body: checkTokenExpiration) {
    return this.identity.post('/v1/auth/check_token_expiration', body)
  }

  loginByEmail(body: LoginByEmailRequest) {
    return this.identity2.post<AuthResponse>('/v1/public/auth/login/email', body)
  }

  loginBySms(body: LoginBySmsRequest) {
    return this.identity2.post<AuthResponse>('/v1/public/auth/login/phone', body)
  }

  getResetPasswordLink(body: getResetPasswordLink) {
    return this.identity2.post('/v1/public/auth/reset_password/send_token', body)
  }

  getMagicLink(body: getMagicLink) {
    return this.identity2.post('/v1/public/auth/login/magic_link/send_token', body)
  }

  loginViaMagicLink(body: loginByMagicLink) {
    return this.identity2.post('/v1/public/auth/login/magic_link', body)
  }

  loginViaSocialNetwork(body: loginBySocialNetwork) {
    return this.identity2.post('/v1/public/auth/login/social', body)
  }

  logout() {
    return this.identity2.post('/v1/private/auth/logout')
  }

  resetPasswordByToken(body: ResetPasswordByTokenRequest) {
    return this.identity2.post('/v1/public/auth/reset_password', body)
  }

  verifyEmail(body: VerifyEmailRequest) {
    return this.identity2.post('/v1/public/auth/verify_email', body)
  }
}
